


























import { Component, Vue, Watch } from 'vue-property-decorator';
import FlTacList from '@/components/FlTacList.vue';

@Component({
  components: {
    FlTacList,
  },
})
export default class Index extends Vue {
  private activeSelect: number = 0;

  changeTarget(field: number) {
    if (field === this.activeSelect) return;
    this.activeSelect = field; // OK
  }
}
